if (!customElements.get('media-carousel')) {
  class MediaCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.media-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.media-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('.media-carousel__dot'));
      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.syncFromScroll(), 60);
      });

      ['mouseenter', 'focusin', 'touchstart'].forEach((type) =>
        this.addEventListener(type, () => this.stop(), { passive: true })
      );
      ['mouseleave', 'focusout', 'touchend'].forEach((type) =>
        this.addEventListener(type, () => this.start(), { passive: true })
      );
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      // Theme editor: jump to the selected slide block.
      document.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.indexOf(event.target);
        if (i === -1) return;
        this.stop();
        this.goTo(i, true);
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      if (!this.autoplay || this.reducedMotion) return;
      this.stop();
      this.timer = setInterval(() => this.goTo((this.index + 1) % this.slides.length), this.speed);
    }

    stop() {
      clearInterval(this.timer);
    }

    goTo(i, instant = false) {
      this.track.scrollTo({
        left: this.slides[i].offsetLeft,
        behavior: instant || this.reducedMotion ? 'auto' : 'smooth',
      });
      this.setActive(i);
    }

    syncFromScroll() {
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      this.setActive(Math.min(Math.max(i, 0), this.slides.length - 1));
    }

    setActive(i) {
      this.index = i;
      this.dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === i);
        dot.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }
  }

  customElements.define('media-carousel', MediaCarousel);
}
